<template>
  <div class="row">
    <spinner v-if="loading.organizationSettings"></spinner>
    <form v-else data-vv-scope="email-settings">
      <div class="col-md-5">
        <div class="form-group">
          <label>Logo</label>
          <image-render
            v-model="data.logo"
            :field="{name: 'email-logo', button: 'Upload logo'}"
            folder="organization_settings"
          />
        </div>
        <form-input
          v-model="data.emailAddress"
          label="Reply to address"
          name="email-address"
          validation-scope="email-settings"
          validators="email|required"
        />
        <form-input
          v-model="data.organizationName"
          label="Organization name"
          name="organization-name"
          validation-scope="email-settings"
          validators="required"
        />
        <form-input
          v-model="data.senderName"
          label="Sender name"
          name="sender-name"
          validation-scope="email-settings"
          validators="required"
        />
        <form-input
          v-model="data.footerText"
          label="Footer text"
          name="footer-text"
          type="textarea"
          validation-scope="email-settings"
          validators="required"
        />
        <button class="btn green" @click.prevent="save()">Save</button>
      </div>
    </form>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

import Spinner from "@/components/Spinner";
import FormInput from "@/components/forms/FormInput";
import ImageRender from "@/components/formbuilder/render/ImageRender";

export default {
  components: {
    Spinner,
    FormInput,
    ImageRender,
  },
  computed: {
    ...mapGetters({
      data: 'emails/getOrganizationSettings',
      loading: 'emails/getLoading',
      currentOrganization: 'getOrganization',
    }),
  },
  methods: {
    ...mapActions({
      updateOrganizationSettings: "emails/updateOrganizationSettings",
      fetchOrganizationSettings: "emails/fetchOrganizationSettings",
    }),
    async save() {
      if (await this.$validator.validateAll('email-settings')) {
        this.updateOrganizationSettings({
          organizationId: this.currentOrganization.id,
          ...this.data
        }).then(() => {
          this.$notify('Changes saved!');
        });
      }
    },
  },
  mounted() {
    this.fetchOrganizationSettings({
      organizationId: this.currentOrganization.id
    });
  }
}
</script>



// WEBPACK FOOTER //
// OrganizationEmailSettings.vue?57cc1f0e